<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-10 col-md-2 col-sm-1">
          <h4 class="card-title">AWS Reservations Portfolio</h4>              
          <div slot="content">
            <enhanced-table :datalist="aws_reservations"/>
          </div>
          </div>
      </div>
    </div>
  </div>
  
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'

  import { formatMoney, formatSimple } from 'src/globalVariables'


  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    created() {
      axios
        .get('reservation')
        .then(response => (this.aws_reservations = response.data))
    },
    data () {
      return {
        aws_reservations:[],
      }
    }
  }
</script>
<style>

</style>
